"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndConvertParams = validateAndConvertParams;
const convertEnum_1 = require("./convertEnum");
const convertBoolean_1 = require("./convertBoolean");
function validateAndConvertParams(params, layer, log) {
    const shimBackgroundType = (0, convertEnum_1.convertEnum)(params.shimBackgroundType, ['OPAQUE', 'TRANSPARENT'], "OPAQUE" /* ShimBackgroundTypeV2.OPAQUE */, log.warn);
    const disableReturnFocus = (0, convertBoolean_1.convertBoolean)(params.disableReturnFocus, false);
    const userClosable = (0, convertBoolean_1.convertBoolean)(params.userClosable, true);
    switch (layer) {
        case 'content':
            return {
                fa: params.fa,
                layer: layer,
                size: undefined,
                shimBackgroundType,
                disableReturnFocus,
                userClosable,
            };
            break;
        case 'interaction': {
            const size = params.size || 'A';
            if (isInteractionLayerSize(size)) {
                return {
                    fa: params.fa,
                    layer: layer,
                    size,
                    shimBackgroundType,
                    disableReturnFocus,
                    userClosable,
                };
            }
            log.warn(`focus interaction layer size ${params.size} is invalid`);
            break;
        }
        case 'focus': {
            const focusSize = params.size || 'A';
            if (isFocusLayerSize(focusSize)) {
                return {
                    fa: params.fa,
                    layer: layer,
                    size: focusSize,
                    shimBackgroundType,
                    disableReturnFocus,
                    userClosable,
                };
            }
            log.warn(`focus layer size ${params.size} is invalid`);
            break;
        }
    }
    return undefined;
}
function isInteractionLayerSize(size) {
    return ['A', 'B', 'C', 'D', 'E'].includes(size);
}
function isFocusLayerSize(size) {
    return ['A', 'B', 'C', 'NONE'].includes(size);
}
//# sourceMappingURL=validateAndConvertParams.js.map